import { getMode } from "./payload";

// Builds the endpoint URL for an ExpressCheckout submission.
// - one_time     => MoneyIn/getpaid?async=false[&includeDetails=...]
// - autopay      => Subscription/add (no query params)
// - tokenization => TokenStorage/add (no query params)
export function getEndpoint(urlApi, config) {
  const mode = getMode(config);

  if (mode === 'autopay') {
    return new URL(urlApi + 'Subscription/add');
  }

  if (mode === 'tokenization') {
    return new URL(urlApi + 'TokenStorage/add');
  }

  const url = new URL(urlApi + 'MoneyIn/getpaid');
  url.searchParams.set('async', 'false');
  const includeDetails = config?.expressCheckout?.includeDetails;
  if (includeDetails) {
    url.searchParams.set('includeDetails', includeDetails);
  }
  return url;
}

// Submits the payload to the correct endpoint and returns { ok, data }.
// Never throws on non-2xx — the caller is responsible for interpreting the
// Payabli envelope (data.responseText === "Success") and mapping to the
// wallet-specific result contract (ApplePaySession status / Google Pay
// transactionState).
export async function submitExpressCheckoutPayment({
  urlApi,
  token,
  config,
  payload,
} = {}) {
  const url = getEndpoint(urlApi, config);

  const response = await fetch(url.href, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      requestToken: token,
    },
  });

  const data = await response.json();
  return { ok: response.ok, data };
}
